export default "__VITE_ASSET__6df7d1c3__"